module.exports = "<p>\r\n  simple-master works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/master-page/master-page.component.html
// module id = ./src/app/components/page/master-page/master-page.component.html
// module chunks = main